import { IPicture } from '@api/models/image/picture';

export enum VideoSubType {
  Highlight = 'highlight',
  Replay = 'replay',
  News = 'news',
}

export interface IVideo {
  _id?: string;
  bm_player_url?: string;
  caption?: string;
  krone_id?: number;
  url?: string;
  userid?: string;
  videoid?: string;
  subtype?: VideoSubType;
  preview?: IPicture;
  preview_url?: string;
  paywall?: boolean;
  liveStream?: boolean;
  gcoreid?: number;
}
